class HeroParallax {
  constructor() {
    this.heroes = document.querySelectorAll('[data-parallax]');
    this.init();
  }

  init() {
    if (this.heroes.length === 0) return;
    
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.setupParallax();
  }

  setupParallax() {
    this.heroes.forEach(hero => {
      const image = hero.querySelector('.hero-enhanced__image');
      if (!image) return;

      let ticking = false;

      const updateParallax = () => {
        const rect = hero.getBoundingClientRect();
        const scrolled = window.pageYOffset;
        const rate = scrolled * 0.5;

        if (rect.bottom >= 0 && rect.top <= window.innerHeight) {
          image.style.transform = `translate3d(0, ${rate}px, 0)`;
        }

        ticking = false;
      };

      const requestTick = () => {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      };

      window.addEventListener('scroll', requestTick, { passive: true });
    });
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new HeroParallax());
} else {
  new HeroParallax();
}

// Reinitialize in theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => new HeroParallax());
}

